<!-- Bulk Operations Component -->
<div class="bulk-operations-container" *ngIf="activities.length > 0">
  
  <!-- Selection Summary -->
  <div class="selection-summary mb-3">
    <div class="card border-primary">
      <div class="card-body py-2">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="form-check">
              <input 
                class="form-check-input" 
                type="checkbox" 
                id="selectAll" 
                [checked]="isAllSelected()"
                [indeterminate]="isPartiallySelected()"
                (change)="toggleSelectAll()">
              <label class="form-check-label fw-medium" for="selectAll">
                Selectează toate activitățile
              </label>
            </div>
            <small class="text-muted">
              {{ selectedCount }} din {{ activities.length }} activități selectate
            </small>
          </div>
          <div class="col-md-6 text-md-end">
            <span class="badge bg-primary fs-6" *ngIf="hasSelection">
              {{ selectedCount }} selectate
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Activities List with Selection -->
  <div class="activities-selection mb-4" *ngIf="activities.length > 0">
    <div class="card">
      <div class="card-header">
        <h6 class="card-title mb-0">
          <mat-icon class="me-2">fact_check</mat-icon>
          Selectează activitățile pentru operații în masă
        </h6>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-sm table-hover mb-0">
            <thead class="table-light">
              <tr>
                <th style="width: 50px;">
                  <input 
                    type="checkbox" 
                    class="form-check-input"
                    [checked]="isAllSelected()"
                    [indeterminate]="isPartiallySelected()"
                    (change)="toggleSelectAll()">
                </th>
                <th>Activitate</th>
                <th>Data/Ora</th>
                <th>Status</th>
                <th>Asignat</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                *ngFor="let activity of activities; trackBy: trackByActivityId" 
                [class.table-active]="isActivitySelected(activity.id)"
                (click)="toggleActivitySelection(activity.id)"
                style="cursor: pointer;">
                <td>
                  <input 
                    type="checkbox" 
                    class="form-check-input"
                    [checked]="isActivitySelected(activity.id)"
                    (click)="$event.stopPropagation()"
                    (change)="toggleActivitySelection(activity.id)">
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <mat-icon class="me-2 text-primary">{{ getActivityTypeIcon(activity) }}</mat-icon>
                    <div>
                      <div class="fw-medium">{{ activity.activity_type?.name || 'Tip necunoscut' }}</div>
                      <small class="text-muted" *ngIf="activity.title">{{ activity.title }}</small>
                    </div>
                  </div>
                </td>
                <td>
                  <div>{{ activity.scheduled_date | date:'dd/MM/yyyy' }}</div>
                  <small class="text-muted">{{ activity.start_time | slice:0:5 }} - {{ activity.end_time | slice:0:5 }}</small>
                </td>
                <td>
                  <span class="badge" [ngClass]="getStatusClass(activity.status)">
                    {{ getStatusLabel(activity.status) }}
                  </span>
                </td>
                <td>
                  <small class="text-muted">{{ getAssignedLabel(activity) }}</small>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Bulk Operations Buttons -->
  <div class="bulk-operations-actions" *ngIf="hasSelection">
    <div class="card border-warning">
      <div class="card-header bg-warning bg-opacity-10">
        <h6 class="card-title mb-0">
          <mat-icon class="me-2">settings</mat-icon>
          Operații în masă ({{ selectedCount }} activități)
        </h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="d-flex flex-wrap">
              <button
                *ngFor="let operation of bulkOperations"
                type="button"
                [class]="getOperationClass(operation)"
                [disabled]="!canExecuteOperation(operation) || isProcessing"
                (click)="startBulkOperation(operation)"
                [attr.title]="operation.description">
                <mat-icon class="me-1">{{ operation.icon }}</mat-icon>
                {{ operation.label }}
              </button>
            </div>
          </div>
        </div>
        
        <!-- Operation Description -->
        <div class="mt-3">
          <div class="alert alert-info d-flex align-items-center" role="alert">
            <mat-icon class="me-2">info</mat-icon>
            <div>
              <strong>Sfat:</strong> Selectați activitățile de mai sus și alegeți o operație pentru a o aplica în masă.
              Unele operații pot fi disponibile doar pentru anumite tipuri de status.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Processing State -->
  <div class="processing-overlay" *ngIf="isProcessing">
    <div class="card">
      <div class="card-body text-center">
        <div class="spinner-border text-primary mb-3" role="status">
          <span class="visually-hidden">Se procesează...</span>
        </div>
        <h6>Se procesează operația...</h6>
        <p class="text-muted mb-0">Vă rugăm să așteptați, se aplică modificările pentru {{ selectedCount }} activități.</p>
      </div>
    </div>
  </div>
</div>

<!-- Bulk Operation Modal -->
<div class="modal fade" [class.show]="showOperationModal" [style.display]="showOperationModal ? 'block' : 'none'" 
     *ngIf="currentOperation && showOperationModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <mat-icon class="me-2">{{ currentOperation.icon }}</mat-icon>
          {{ currentOperation.label }} - {{ selectedCount }} activități
        </h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>
      
      <form [formGroup]="bulkForm" (ngSubmit)="executeOperation()">
        <div class="modal-body">
          <div class="alert alert-info d-flex align-items-start">
            <mat-icon class="me-2 mt-1">{{ currentOperation.icon }}</mat-icon>
            <div>
              <strong>{{ currentOperation.label }}</strong><br>
              {{ currentOperation.description }}<br>
              <small class="text-muted">Se va aplica pentru {{ selectedCount }} activități selectate.</small>
            </div>
          </div>

          <!-- Reschedule Form -->
          <div *ngIf="currentOperation.type === 'reschedule'">
            <div class="row">
              <div class="col-md-4">
                <label for="newDate" class="form-label">Noua dată</label>
                <input 
                  type="date" 
                  id="newDate" 
                  class="form-control" 
                  formControlName="newDate"
                  [class.is-invalid]="bulkForm.get('newDate')?.invalid && bulkForm.get('newDate')?.touched">
              </div>
              <div class="col-md-4">
                <label for="newStartTime" class="form-label">Ora început</label>
                <input 
                  type="time" 
                  id="newStartTime" 
                  class="form-control" 
                  formControlName="newStartTime"
                  [class.is-invalid]="bulkForm.get('newStartTime')?.invalid && bulkForm.get('newStartTime')?.touched">
              </div>
              <div class="col-md-4">
                <label for="newEndTime" class="form-label">Ora sfârșit</label>
                <input 
                  type="time" 
                  id="newEndTime" 
                  class="form-control" 
                  formControlName="newEndTime"
                  [class.is-invalid]="bulkForm.get('newEndTime')?.invalid && bulkForm.get('newEndTime')?.touched">
              </div>
            </div>
            <div class="mt-3">
              <label for="rescheduleReason" class="form-label">Motivul reprogramării</label>
              <textarea 
                id="rescheduleReason" 
                class="form-control" 
                rows="3" 
                formControlName="rescheduleReason"
                [class.is-invalid]="bulkForm.get('rescheduleReason')?.invalid && bulkForm.get('rescheduleReason')?.touched"
                placeholder="Specificați motivul pentru reprogramare..."></textarea>
            </div>
          </div>

          <!-- Cancel Form -->
          <div *ngIf="currentOperation.type === 'cancel'">
            <div class="mb-3">
              <label for="cancelReason" class="form-label">Motivul anulării *</label>
              <textarea 
                id="cancelReason" 
                class="form-control" 
                rows="4" 
                formControlName="cancelReason"
                [class.is-invalid]="bulkForm.get('cancelReason')?.invalid && bulkForm.get('cancelReason')?.touched"
                placeholder="Specificați motivul pentru anularea activităților..."></textarea>
              <div class="invalid-feedback">
                Motivul anulării este obligatoriu (minimum 10 caractere).
              </div>
            </div>
          </div>

          <!-- Complete Form -->
          <div *ngIf="currentOperation.type === 'complete'">
            <div class="mb-3">
              <label for="completionDate" class="form-label">Data finalizării</label>
              <input 
                type="date" 
                id="completionDate" 
                class="form-control" 
                formControlName="completionDate">
            </div>
            <div class="mb-3">
              <label for="completionNotes" class="form-label">Notițe finalizare</label>
              <textarea 
                id="completionNotes" 
                class="form-control" 
                rows="3" 
                formControlName="completionNotes"
                placeholder="Adăugați notițe despre finalizarea activităților..."></textarea>
            </div>
          </div>

          <!-- Assign Form -->
          <div *ngIf="currentOperation.type === 'assign'">
            <div class="mb-3">
              <label for="newOperatorId" class="form-label">Operator destinație *</label>
              <select 
                id="newOperatorId" 
                class="form-select" 
                formControlName="newOperatorId"
                [class.is-invalid]="bulkForm.get('newOperatorId')?.invalid && bulkForm.get('newOperatorId')?.touched">
                <option value="">Selectați operatorul...</option>
                <option *ngFor="let operator of availableOperators" [value]="operator.id">
                  {{ operator.name }} - {{ operator.department }}
                </option>
              </select>
              <div class="invalid-feedback">
                Selectarea operatorului este obligatorie.
              </div>
            </div>
            <div class="mb-3">
              <label for="assignmentNotes" class="form-label">Notițe reasignare</label>
              <textarea 
                id="assignmentNotes" 
                class="form-control" 
                rows="3" 
                formControlName="assignmentNotes"
                placeholder="Adăugați informații despre reasignare..."></textarea>
            </div>
          </div>

          <!-- Change Type Form -->
          <div *ngIf="currentOperation.type === 'change_type'">
            <div class="mb-3">
              <label for="newActivityTypeId" class="form-label">Noul tip de activitate *</label>
              <select 
                id="newActivityTypeId" 
                class="form-select" 
                formControlName="newActivityTypeId"
                [class.is-invalid]="bulkForm.get('newActivityTypeId')?.invalid && bulkForm.get('newActivityTypeId')?.touched">
                <option value="">Selectați tipul de activitate...</option>
                <option *ngFor="let type of activityTypes" [value]="type.id">
                  {{ type.name }}
                </option>
              </select>
              <div class="invalid-feedback">
                Selectarea tipului de activitate este obligatorie.
              </div>
            </div>
            <div class="mb-3">
              <label for="typeChangeReason" class="form-label">Motivul schimbării</label>
              <textarea 
                id="typeChangeReason" 
                class="form-control" 
                rows="3" 
                formControlName="typeChangeReason"
                placeholder="Specificați motivul pentru schimbarea tipului..."></textarea>
            </div>
          </div>

          <!-- Add Notes Form -->
          <div *ngIf="currentOperation.type === 'add_notes'">
            <div class="mb-3">
              <label for="notesCategory" class="form-label">Categoria notițelor</label>
              <select id="notesCategory" class="form-select" formControlName="notesCategory">
                <option value="general">General</option>
                <option value="important">Important</option>
                <option value="follow_up">Follow-up</option>
                <option value="administrative">Administrativ</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="additionalNotes" class="form-label">Notițele de adăugat *</label>
              <textarea 
                id="additionalNotes" 
                class="form-control" 
                rows="4" 
                formControlName="additionalNotes"
                [class.is-invalid]="bulkForm.get('additionalNotes')?.invalid && bulkForm.get('additionalNotes')?.touched"
                placeholder="Introduceți notițele care vor fi adăugate la toate activitățile selectate..."></textarea>
              <div class="invalid-feedback">
                Notițele sunt obligatorii (minimum 5 caractere).
              </div>
            </div>
          </div>

          <!-- Export Form -->
          <div *ngIf="currentOperation.type === 'export'">
            <div class="row">
              <div class="col-md-6">
                <label for="exportFormat" class="form-label">Format export</label>
                <select id="exportFormat" class="form-select" formControlName="exportFormat">
                  <option value="excel">Excel (.xlsx)</option>
                  <option value="pdf">PDF</option>
                  <option value="csv">CSV</option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Opțiuni</label>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="includeDetails" formControlName="includeDetails">
                  <label class="form-check-label" for="includeDetails">
                    Include detalii complete
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="includeHistory" formControlName="includeHistory">
                  <label class="form-check-label" for="includeHistory">
                    Include istoric modificări
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- Selected Activities Preview -->
          <div class="selected-activities-preview mt-4">
            <h6 class="text-muted">Activități selectate:</h6>
            <div class="bg-light p-3 rounded" style="max-height: 200px; overflow-y: auto;">
              <div class="row g-2">
                <div *ngFor="let activity of selectedActivitiesData" class="col-12">
                  <div class="d-flex align-items-center">
                    <mat-icon class="me-2 text-muted small">event</mat-icon>
                    <small>
                      {{ activity.activity_type?.name || 'Necunoscut' }} - 
                      {{ activity.scheduled_date | date:'dd/MM/yyyy' }} 
                      {{ activity.start_time | slice:0:5 }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeModal()" [disabled]="isProcessing">
            Anulează
          </button>
          <button 
            type="submit" 
            class="btn"
            [class.btn-danger]="currentOperation.dangerLevel === 'high'"
            [class.btn-warning]="currentOperation.dangerLevel === 'medium'"
            [class.btn-primary]="currentOperation.dangerLevel === 'low'"
            [disabled]="isProcessing || (currentOperation.requiresForm && !bulkForm.valid)">
            <mat-icon class="me-1">{{ currentOperation.icon }}</mat-icon>
            {{ isProcessing ? 'Se procesează...' : currentOperation.label }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div class="modal-backdrop fade show" *ngIf="showOperationModal"></div>